import api from "shared/api";
import { ProjectRaw } from "./models";
import { FileEntryRaw } from "./models/fileEntry";

const prefix = "api/projectsupload";

export const getProjectsForCurrentUser = async (): Promise<ProjectRaw[]> => {
  const res = await api().get<ProjectRaw[]>(`${prefix}/current-user`);
  return res.data;
};

export const getSubscriptionsForCurrentUser = async (): Promise<
  ProjectRaw[]
> => {
  const res = await api().get<ProjectRaw[]>(
    `${prefix}/current-user/subscriptions`
  );
  return res.data;
};

export const getProjectByID = async (id: number): Promise<ProjectRaw> => {
  const res = await api().get<ProjectRaw>(`${prefix}/${id}`);
  return res.data;
};

export const getProjectFileOverview = async (
  id: number
): Promise<FileEntryRaw[]> => {
  const res = await api().get<FileEntryRaw[]>(`${prefix}/${id}/archive`);
  return res.data;
};

export const postArchive = async (
  id: number,
  file: File,
  description: string
): Promise<void> => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("description", description);

  await api().post(`${prefix}/${id}/archive`, formData, {
    headers: { "content-type": "multipart/form-data" },
  });
};
